import { Download } from "lucide-react";

export default function HowToDownload({ howto, resolveUrl }) {
  const steps = Array.from({ length: 4 }).map((_, i) => howto.find((h) => h.step === i + 1) || { step: i + 1, image_url: "" });
  const anyImage = steps.some((s) => s.image_url);
  if (!anyImage) return null;

  return (
    <section className="bg-dark px-3 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="howto-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <div className="label-gold">Easy Steps</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#ffd700] mt-2">
            How To Download
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s) => (
            <div key={s.step} className="cream-card p-3 relative" data-testid={`howto-step-${s.step}`}>
              <div className="absolute -top-3 -left-3 w-9 h-9 rounded-full bg-navy text-[#ffd700] flex items-center justify-center font-display font-bold shadow-md">
                {s.step}
              </div>
              <div className="aspect-[3/4] rounded-md overflow-hidden bg-[#f0e5d2] flex items-center justify-center">
                {s.image_url ? (
                  <img src={resolveUrl(s.image_url)} alt={`step-${s.step}`} className="w-full h-full object-cover" />
                ) : (
                  <div className="text-center p-4">
                    <Download className="w-10 h-10 text-[#b8001f]/40 mx-auto mb-2" />
                    <div className="text-xs text-[#6b6455]">Step {s.step}</div>
                  </div>
                )}
              </div>
              <div className="mt-3 font-display font-semibold text-navy text-center">Step {s.step}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
